import React, {MouseEvent, ReactElement, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {DbUserService} from "../../../services/db/dbUserService";
import {ResponseResultCode} from "../../../model/response-api";
import moment from "moment/moment";
import {DocuBizPlnd} from "../../../model/cp/DocuBizPlnd";
import DashboardLoading from "./DashboardLoading";
import DashboardNoData from "./DashboardNoData";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";

export default function BizPlndStatus(props: Readonly<DashboardModuleProps>) {
  const [list, setList] = useState<ReactElement[]>([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    DbUserService.getInstance().fetchCpBizplnd().then(response => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        if (response.data && response.data.length > 0) {
          setList(response.data.map((f, i) => templateBizplndBox(f, i)))
        }
      }
    }).finally(() => {
      setIsLoading(false);
    });
  }, []);

  function templateBizplndBox(data: DocuBizPlnd, index: number) {
    return (
      <li key={data.docId}>
        <Link to="#" onClick={(e) => handleClickLi(e, data)}>
          <span>
            {data.rlvnDataNm}
          </span>
        </Link>
        <span>{moment(data.regDate).format('YYYY-MM-DD')}</span>
      </li>
    )
  }

  function handleClickLi(e: MouseEvent<HTMLAnchorElement>, data: any) {
    e.preventDefault();
    navigate(`/cp/reduce/history/business/detail/${data.docId}`);
  }

  return(
    <DashboardCard
      title="외부사업 현황"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/cp/reduce/history"
      dashboardConfig={props.dashboardConfig}
    >
      <DashboardLoading isLoading={isLoading}/>
      <div className="notice-wrap">
        {list && list?.length > 0 ? (
          <ul className="notice">
            {(list && list.length > 0) && list.map((item: any) => item)}
          </ul>
        ) : (
          <DashboardNoData
            message="진행 중인 배출권거래제 외부사업이 없습니다."
            link={{text: '외부사업 신청하기', to: '/cp/reduce/methodology'}}
          />
        )}
      </div>
    </DashboardCard>
  )
}